import { env } from '~/lib/env';
import type { variables } from '~/lib/variables';
import type { FeatureFlagKey } from '~/modules/experiments/features';
import { isLocalhost } from '~/modules/experiments/utils/isLocalhost';

import { useFeatureFlagContext } from './useFeatureFlagContext';

function useFeatureFlags(keys: FeatureFlagKey[]) {
  const client = useFeatureFlagContext();

  return keys.map((key) => {
    const e2eOverride = (
      window as unknown as { __E2E_FEATURE_FLAGS__: Record<string, boolean> }
    )?.__E2E_FEATURE_FLAGS__?.[key];

    if (typeof e2eOverride === 'boolean') {
      return e2eOverride;
    }

    if (isLocalhost()) {
      const localEnvKey = `VITE_${key.toUpperCase()}`;
      const localValue = env(localEnvKey as keyof typeof variables, false);

      if (localValue !== undefined && localValue !== '') {
        return localValue === 'true';
      }
    }

    return client?.getBooleanValue(key, false) || false;
  });
}

export { useFeatureFlags };
